var fr = { exports: {} };
export {
  fr as __module
};
//# sourceMappingURL=fr2.js.map
